import Vue from 'vue'
import App from './app.vue'
import router from './router'
import vSelect from 'vue-select'

// This registers the component allowing me to use 'Vue Select'
// Not entirely sure this is the right spot, but it works for now. 
Vue.component('v-select', vSelect)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
